import React from "react";
import About_Banner from "./about-banner/About_Banner";
import Majestry_Story from "./majestry-story/Majestry_Story";
import Why_Majestry from "./why_majestry/Why_Majestry";
import Pillars_Of_Majestry from "./pillars-of-majestry/Pillars_Of_Majestry";
import GlobalFamilySleepers from "./global-family-sleepers/Global_Family_Sleepers";
import OurPromise from "./our-promise-to-us/Our_Promise_To_Us";


function About_Us() {
  return (
    <>
      <About_Banner />
      <Majestry_Story />
      <Why_Majestry />
      <Pillars_Of_Majestry />
      <GlobalFamilySleepers />
      <OurPromise />
    </>
  );
}

export default About_Us;
